import { VariantPickerListItem } from 'autogen/swagger/all';
import styled from 'styled-components';
import { Spacing16, Spacing8 } from 'autogen/design-tokens/tokens';
import { customScrollbar } from 'modules/helpers/mixins';
import ScrollSnapSlider, {
    IOptions,
    ScrollSnapSliderContext,
    useScrollSnapSlider
} from 'components/generic/ScrollSnapSlider';
import { hover } from 'variables';
import HorizontalItem from './HorizontalItem';
import { containerPadding, sliderPadding } from './shared/styles';
import ListHeader from './ListHeader';

// #region Styles
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${Spacing16};
`;

const StyledHorizontalItem = styled(HorizontalItem)`
    scroll-snap-align: start;
`;

const HorizontalScrollContainer = styled(ScrollSnapSlider)`
    position: relative;
    gap: ${Spacing8};
    padding-bottom: ${Spacing8};

    ${containerPadding}
    ${sliderPadding}

    ${hover('hover')} {
        padding-bottom: 0;
        ${customScrollbar}
    }
`;

// #endregion Styles

const scrollSnapSliderOptions: IOptions = {
    autoplay: false,
    draggable: true,
    loop: false
};

export default function HorizontalList({ variants }: { variants: VariantPickerListItem[] }) {
    const { ref, slider } = useScrollSnapSlider(scrollSnapSliderOptions);
    const selectedItem = variants.find((item) => item.isSelected);

    return (
        <Wrapper>
            {selectedItem && <ListHeader variant={selectedItem} layoutType="Horizontal" />}
            <ScrollSnapSliderContext.Provider value={slider}>
                <HorizontalScrollContainer ref={ref}>
                    {variants.map((variant, index) => (
                        <StyledHorizontalItem
                            item={variant}
                            radioGroupName={`variantSection_${index}`}
                            key={variant.productId}
                        />
                    ))}
                </HorizontalScrollContainer>
            </ScrollSnapSliderContext.Provider>
        </Wrapper>
    );
}
